<template>
  <section class="breakeven-percentage-for-bluffing-the-turn-inputs">
    <togglable-section title="Basics">
      <li class="list-group-item">
        <span>Turn pot size:</span>
        <section class="input-group">
          <span class="input-group-addon">$</span>
          <input
            type="number"
            class="form-control"
            min="0"
            step="5"
            v-bind:value="state.turnPotSize"
            v-bind:disabled="!authorized"
            v-on:input="$store.commit('breakevenPercentageForBluffingTheTurn/setTurnPotSize', $event.target.valueAsNumber)"
          >
        </section>
      </li>
      <li class="list-group-item">
        <span>Turn bet size (% of pot):</span>
        <section class="input-group">
          <input
            type="number"
            class="form-control"
            min="0"
            step="5"
            v-bind:value="state.turnBetSize"
            v-bind:disabled="!authorized"
            v-on:input="$store.commit('breakevenPercentageForBluffingTheTurn/setTurnBetSize', $event.target.valueAsNumber)"
          >
          <span class="input-group-addon">%</span>
        </section>
      </li>
    </togglable-section>
    <togglable-section title="Hitting an out">
      <li class="list-group-item">
        <span>Number of outs:</span>
        <input
          type="number"
          class="form-control"
          min="0"
          max="46"
          step="1"
          v-bind:value="state.numberOfOuts"
          v-bind:disabled="!authorized"
          v-on:input="$store.commit('breakevenPercentageForBluffingTheTurn/setNumberOfOuts', $event.target.valueAsNumber)"
        >
      </li>
      <li v-if="state.numberOfOuts > 0" class="list-group-item">
        <span>Extra money won on river when you hit an out (% of river pot):</span>
        <section class="input-group">
          <input
            type="number"
            class="form-control"
            min="0"
            step="5"
            v-bind:value="state.percentageOfPotWonOnRiverWhenYouHitAnOut"
            v-bind:disabled="!authorized"
            v-on:input="$store.commit('breakevenPercentageForBluffingTheTurn/setPercentageOfPotWonOnRiverWhenYouHitAnOut', $event.target.valueAsNumber)"
          >
          <span class="input-group-addon">%</span>
        </section>
      </li>
    </togglable-section>
    <togglable-section title="Following up with a river bluff">
      <li class="list-group-item">
        <span>Number of river cards you'll bluff:</span>
        <input
          type="number"
          class="form-control"
          min="0"
          max="46"
          step="1"
          v-bind:value="state.numRiverCardsYoullBluff"
          v-bind:disabled="!authorized"
          v-on:input="$store.commit('breakevenPercentageForBluffingTheTurn/setNumRiverCardsYoullBluff', $event.target.valueAsNumber)"
        >
      </li>
      <li v-if="state.numRiverCardsYoullBluff > 0" class="list-group-item">
        <span>River bluff size (% of river pot):</span>
        <section class="input-group">
          <input
            type="number"
            class="form-control"
            min="0"
            step="5"
            v-bind:value="state.riverBluffSize"
            v-bind:disabled="!authorized"
            v-on:input="$store.commit('breakevenPercentageForBluffingTheTurn/setRiverBluffSize', $event.target.valueAsNumber)"
          >
          <span class="input-group-addon">%</span>
        </section>
      </li>
      <li v-if="state.numRiverCardsYoullBluff > 0" class="list-group-item">
        <span>Probability of getting a fold on the river:</span>
        <section class="input-group">
          <input
            type="number"
            class="form-control"
            min="0"
            max="100"
            step="5"
            v-bind:value="state.probabilityOfGettingFoldOnRiver"
            v-bind:disabled="!authorized"
            v-on:input="$store.commit('breakevenPercentageForBluffingTheTurn/setProbabilityOfGettingFoldOnRiver', $event.target.valueAsNumber)"
          >
          <span class="input-group-addon">%</span>
        </section>
      </li>
    </togglable-section>
    <togglable-section title="EV of checking">
      <section v-if="state.numberOfOuts > 0">
        <li class="list-group-item">
          <span>Are you in position or out of position:</span><br>
          <section class="btn-group">
            <button
              class="btn btn-default"
              v-bind:class="{ 'active': state.position === 'in position' }"
              v-bind:disabled="!authorized"
              v-on:click="$store.commit('breakevenPercentageForBluffingTheTurn/setPosition', 'in position')"
            >
              In position
            </button>
            <button
              class="btn btn-default"
              v-bind:class="{ 'active': state.position === 'out of position' }"
              v-bind:disabled="!authorized"
              v-on:click="$store.commit('breakevenPercentageForBluffingTheTurn/setPosition', 'out of position')"
            >
              Out of position
            </button>
          </section>
        </li>
        <li v-if="state.position === 'out of position'" class="list-group-item">
          <span>Probability that your opponent bets when you check:</span>
          <section class="input-group">
            <input
              type="number"
              class="form-control"
              min="0"
              max="100"
              step="5"
              v-bind:value="state.probabilityThatOpponentBetsWhenYouCheck"
              v-bind:disabled="!authorized"
              v-on:input="$store.commit('breakevenPercentageForBluffingTheTurn/setProbabilityThatOpponentBetsWhenYouCheck', $event.target.valueAsNumber)"
            >
            <span class="input-group-addon">%</span>
          </section>
        </li>
        <li v-if="state.position === 'out of position' && state.probabilityThatOpponentBetsWhenYouCheck > 0" class="list-group-item">
          <span>Are you calling when your opponent bets:</span><br>
          <div class="btn-group">
            <button
              class="btn btn-default"
              v-bind:class="{ 'active': state.checkCall }"
              v-bind:disabled="!authorized"
              v-on:click="$store.commit('breakevenPercentageForBluffingTheTurn/setCheckCall', true)"
            >
              Call
            </button>
            <button
              class="btn btn-default"
              v-bind:class="{ 'active': !state.checkCall }"
              v-bind:disabled="!authorized"
              v-on:click="$store.commit('breakevenPercentageForBluffingTheTurn/setCheckCall', false)"
            >
              Fold
            </button>
          </div>
        </li>
        <li v-if="state.position === 'out of position' && state.probabilityThatOpponentBetsWhenYouCheck > 0 && state.checkCall" class="list-group-item">
          <span>Opponent's turn bet size (% of pot):</span>
          <section class="input-group">
            <input
              type="number"
              class="form-control"
              min="0"
              step="5"
              v-bind:value="state.opponentsTurnBetSize"
              v-bind:disabled="!authorized"
              v-on:input="$store.commit('breakevenPercentageForBluffingTheTurn/setOpponentsTurnBetSize', $event.target.valueAsNumber)"
            >
            <span class="input-group-addon">%</span>
          </section>
        </li>
        <li v-if="state.position === 'out of position' && state.probabilityThatOpponentBetsWhenYouCheck > 0 && state.checkCall" class="list-group-item">
          <span>Extra money won when you hit an out after you check/call (% of river pot):</span>
          <section class="input-group">
            <input
              type="number"
              class="form-control"
              min="0"
              step="5"
              v-bind:value="state.percentageOfPotWonAfterCheckCall"
              v-bind:disabled="!authorized"
              v-on:input="$store.commit('breakevenPercentageForBluffingTheTurn/setPercentageOfPotWonAfterCheckCall', $event.target.valueAsNumber)"
            >
            <span class="input-group-addon">%</span>
          </section>
        </li>
        <li v-if="state.position === 'in position' || (state.position === 'out of position' && (state.probabilityThatOpponentBetsWhenYouCheck < 100))" class="list-group-item">
          <span>Extra money won when you hit an out after the turn checks through (% of river pot):</span>
          <section class="input-group">
            <input
              type="number"
              class="form-control"
              min="0"
              step="5"
              v-bind:value="state.percentageOfPotWonAfterTurnChecksThrough"
              v-bind:disabled="!authorized"
              v-on:input="$store.commit('breakevenPercentageForBluffingTheTurn/setPercentageOfPotWonAfterTurnChecksThrough', $event.target.valueAsNumber)"
            >
            <span class="input-group-addon">%</span>
          </section>
        </li>
      </section>
      <p v-if="state.numberOfOuts === 0">
        <em>The EV of checking is 0 because you have 0 outs. When you have 1 or more outs, the EV of checking will depend on some state.</em>
      </p>
    </togglable-section>
  </section>
</template>

<script>
import TogglableSection from '@/components/utilities/togglable-section';

export default {
  name: 'breakeven-percentage-for-bluffing-the-turn-inputs',
  props: ['state', 'authorized'],
  components: {
    'togglable-section': TogglableSection,
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/breakeven-percentage-for-bluffing-the-turn/breakeven-percentage-for-bluffing-the-turn-inputs.vue